/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_Import_CsvInputs */

const en_knp_terms_import_csv = /** @type {(inputs: Knp_Terms_Import_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import CSV`)
};

const fr_knp_terms_import_csv = /** @type {(inputs: Knp_Terms_Import_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importer CSV`)
};

const de_knp_terms_import_csv = /** @type {(inputs: Knp_Terms_Import_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV importieren`)
};

const it_knp_terms_import_csv = /** @type {(inputs: Knp_Terms_Import_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa CSV`)
};

const ru_knp_terms_import_csv = /** @type {(inputs: Knp_Terms_Import_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт CSV`)
};

const es_knp_terms_import_csv = /** @type {(inputs: Knp_Terms_Import_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar CSV`)
};

const zh_cn2_knp_terms_import_csv = /** @type {(inputs: Knp_Terms_Import_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导入 CSV 文件`)
};

const ja_knp_terms_import_csv = /** @type {(inputs: Knp_Terms_Import_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSVをインポート`)
};

const hi_knp_terms_import_csv = /** @type {(inputs: Knp_Terms_Import_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV आयात करें`)
};

const pt_pt2_knp_terms_import_csv = /** @type {(inputs: Knp_Terms_Import_CsvInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar CSV`)
};

/**
* | output |
* | --- |
* | "Import CSV" |
*
* @param {Knp_Terms_Import_CsvInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_import_csv = /** @type {((inputs?: Knp_Terms_Import_CsvInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Import_CsvInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_terms_import_csv(inputs)
	if (locale === "de") return de_knp_terms_import_csv(inputs)
	if (locale === "it") return it_knp_terms_import_csv(inputs)
	if (locale === "ru") return ru_knp_terms_import_csv(inputs)
	if (locale === "es") return es_knp_terms_import_csv(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_terms_import_csv(inputs)
	if (locale === "ja") return ja_knp_terms_import_csv(inputs)
	if (locale === "hi") return hi_knp_terms_import_csv(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_terms_import_csv(inputs)
	return en_knp_terms_import_csv(inputs)
});